// alertService.ts
import { authFetchGET } from '../utils/auth-fetch'

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;
const userAlertApi = (<any>window)["appenv"].services.useralerts;
const env = { ...userAlertApi, ...isVesselOnCloud ? { scope: (<any>window)["appenv"].scope } : {} };

export class AlertService {
    private static apiUrl = "/useralerts/alerts";
    static async getPassedPilotAlert(): Promise<any[]> {
        const params = new URLSearchParams({
            state: "active",
            category: "Plan"
        });

        try {
            const response = await authFetchGET(env.scope, `${env.baseurl}${this.apiUrl}`, {state: 'active', category: 'Plan'});
            if (response) {
                return response;
            } else {
                return [];
            }
        } catch (error) {
            console.error("Error fetching active alerts:", error);
            return [];
        }
    }
}